module.exports = __webpack_public_path__ + "static/media/muralIcons.d719d34b.svg";